import React from "react";

export const SOURCE_LABELS = {
  hubspot: "HubSpot",
  db: "Addy database",
  average: "Running pilots",
  standard: "Team standard",
  list: "Addy list price",
  edited: "Edited",
};

/** Where a number on the calculators came from. */
export function SourceTag({ source }) {
  if (!SOURCE_LABELS[source]) {
    return null;
  }

  return <span className={`pl-source pl-source--${source}`}>{SOURCE_LABELS[source]}</span>;
}
